import { Component, OnInit, TemplateRef } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { PreloaderService } from '@core';
import { DataService } from '@core/bootstrap/data.service';
import { LocalStorage } from '@core/bootstrap/localstorage.service';
import { environment } from '@env/environment';
import { AlertService } from '@shared/components/alert/alert.service';
import { ConfirmationDialog } from '@shared/components/confirmation-dialog/confirmation-dialog.component';
import { LanguagePipe } from '@shared/pipes/language.pipe';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
declare var $:any;
interface list {
  id?: number;
  platform_work_level_id: string,
  platform_work_level_key: string,
  platform_work_level_title_english: string,
  platform_work_level_title_arabic: string,
  writer:string
}
@Component({
  selector: 'app-worklevels',
  templateUrl: './worklevels.component.html',
  styleUrls: ['./worklevels.component.scss']
})
export class WorklevelsComponent implements OnInit {
  modalRefA: BsModalRef;
  form:FormGroup;
  tabledatas: list[];
  collectionSize;
  page                        = 1;
  pageSize                    = 10;
  searchKey                   = "";
  lang_key                    = localStorage.getItem('lang_key') || 'en';
  data:any                    = [];
  admin                       = JSON.parse(this.ls.getItem('is_admin'));
  tabledata:any               = [];
  nodata: string = this.lang.transform('lang_loading');
  constructor(public ds:DataService, public lang:LanguagePipe, public ls:LocalStorage, public spinner:PreloaderService, public alert:AlertService, public modalService: BsModalService, public dialog:MatDialog, public fb:FormBuilder) { }
  ngOnInit(): void {
    this.form = new FormGroup({
      platform_work_level_id              : new FormControl(),
      platform_work_level_key             : new FormControl('', [Validators.required]),
      platform_work_level_title_english   : new FormControl('', [Validators.required]),
      platform_work_level_title_arabic    : new FormControl('', [Validators.required]),
      platform_work_level_sort            : new FormControl('0', [Validators.required]),
    });
    this.load_work_levels();
  }
  public openModalA(template: TemplateRef<any>) {
    this.modalRefA = this.modalService.show(template, environment.modelconfig);
  }
  public load_work_levels() {
    let param = new FormData();
    param.append('search_key',  this.searchKey || '');
    param.append('request',     'list');
    this.ds.getActionByUrl(this.ds.formData2string(param), 'lpworklevel').subscribe(res=>{
      this.spinner.hide();
      if(res.status) {
        this.data           = res;
        this.tabledatas     = res.records;
        this.collectionSize = res.records.length;
        this.build_table_data();
      } else {
        this.data     = [];
        this.nodata   = res.error;
      }
    }, error=> {
      this.spinner.hide();
      this.data     = [];
      this.nodata   = (error && error.error && error.error.error) ? error.error.error : this.lang.transform('lang_internal_server_error');
    })
  }
  public build_table_data() {
    this.tabledata = this.tabledatas.map((list, i) => ({ id: i + 1, ...list })).slice((this.page - 1) * this.pageSize, (this.page - 1) * this.pageSize + this.pageSize);
  }
  public submit() {
    this.spinner.show();
    if(this.form.get('platform_work_level_id').value) {
      this.ds.putActionByUrl(this.ds.formData2string(this.ds.json2formdata(this.form.value)), 'upworklevel/'+this.form.get('platform_work_level_id').value).subscribe(res=>{
        this.spinner.hide();
        if(res.status) {
          this.form.reset();
          this.load_work_levels();
          setTimeout(() => {
            this.modalRefA.hide();
            this.alert.clear();
          }, 1000);
          this.alert.success(res.msg);
        } else {
          this.alert.error(res.error);
        }
      }, error => {
        this.spinner.hide();
        this.alert.error((error && error.error && error.error.error) ? error.error.error : this.lang.transform('lang_internal_server_error'));
      });
    } else {
      this.ds.postActionByUrl(this.ds.json2formdata(this.form.value), 'cpworklevel').subscribe(res=>{
        this.spinner.hide();
        if(res.status) {
          this.form.reset();
          this.load_work_levels();
          setTimeout(() => {
            this.modalRefA.hide();
            this.alert.clear();
          }, 1000);
          this.alert.success(res.msg);
        } else {
          this.alert.error(res.error);
        }
      }, error => {
        this.spinner.hide();
        this.alert.error((error && error.error && error.error.error) ? error.error.error : this.lang.transform('lang_internal_server_error'));
      });
    }
  }
  public checkAllItemsWLe(event) {
    if (event.target.checked) {
      $(".appworklevels .eachItemWLe").prop("checked", true);
      $(".appworklevels .makeback").addClass("bground");
      $(".appworklevels .deleteIconDiv").show();
    } else {
      $(".appworklevels .eachItemWLe").prop("checked", false);
      $(".appworklevels .makeback").removeClass("bground");
      $(".appworklevels .deleteIconDiv").hide();
    }
  }
  public checkEachItemWLe(event) {
    if (event.target.checked) {
      const val = event.target.value;
      $(".appworklevels .removerow" + val).addClass("bground");
    } else {
      const val = event.target.value;
      $(".appworklevels .removerow" + val).removeClass("bground");
    }
    const checkedtotal = [];
    $(".appworklevels .eachItemWLe:checked").each(function () {
      checkedtotal.push($(this).val());
    });
    const totalrow = [];
    $(".appworklevels .eachItemWLe").each(function () {
      totalrow.push($(this).val());
    });
    if (checkedtotal.length > 0) {
      $(".appworklevels .deleteIconDiv").show();
    } else {
      $(".appworklevels .deleteIconDiv").hide();
    }
    if (checkedtotal.length === totalrow.length) {
      $(".appworklevels #allItemsWLe").prop("checked", true);
    } else {
      $(".appworklevels #allItemsWLe").prop("checked", false);
    }
  }
  public deleteBulkDataWLe() {
    const checkedtotal = [];
    $(".appworklevels .eachItemWLe:checked").each(function () {
      checkedtotal.push($(this).val());
    });
    if (checkedtotal.length > 0) {
      const dialogRef = this.dialog.open(ConfirmationDialog,{
        disableClose: true,
        width:'400px',
        data:{
          title: this.lang.transform('lang_confirmation'),
          message: this.lang.transform('lang_are_you_sure'),          
        }
      });
      dialogRef.afterClosed().subscribe((confirmed: boolean) => {
        if (confirmed) {
          this.spinner.show()
          this.ds.deleteActionByUrl(checkedtotal, 'dpworklevel').subscribe(
            (data) => {
              this.spinner.hide()
              if (data.status) {
                this.load_work_levels();
                $(".appworklevels #allItemsWLe").prop("checked", false);
                $(".appworklevels .deleteIconDiv").hide();
                this.ds.dialogf('', data.msg);
              } else {
                this.ds.dialogf('', data.error);
              }
            },
            (error) => {
              this.ds.dialogf('', (error && error.error && error.error.error) ? error.error.error : this.lang.transform('lang_internal_server_error'));
              this.spinner.hide()
            }
          );
        }
      });
    } else {
      this.ds.dialogf();
    }
  }
}
